import React, { useState } from 'react'
import "../../Assets/Css/Tickets.scss"
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { IoCloudUploadOutline } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';

function ReplyTicket({ Fields, setFields, handleFileChange, data }) {
    const location = useLocation();
    data = location?.state?.data?.allData || data;
    const [selectedOption, setSelectedOption] = useState('Submit');
    const [showDropdown, setShowDropdown] = useState(false);

    const navigate = useNavigate();

    const options = [
        { label: 'Submit as Open', color: 'red' },
        { label: 'Submit as Pending', color: 'yellow' },
        { label: 'Submit as Resolved', color: 'green' },
        { label: 'Submit as Closed', color: 'blue' },
    ];

    const handleOptionClick = (option) => {
        setSelectedOption(option.label);
        setShowDropdown(false);
    };
    return (
        <>
            <div className='space_div'>

            </div>
            <div className='footer1'>
                <h6></h6>

                <div className="note-part">
                    <label className='label'>To :<h6 className='labelmodify'>{data?.user?.name || data?.client?.name}</h6></label>
                    <div className="editor-custom ">
                        <CKEditor
                            editor={ClassicEditor}
                            data={Fields?.notes || ""}
                            onReady={editor => {
                                console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setFields({
                                    ...Fields,
                                    notes: data,
                                })
                            }}
                            onBlur={(event, editor) => {
                                console.log('Blur.', editor);
                            }}
                            onFocus={(event, editor) => {
                                console.log('Focus.', editor);
                            }}
                            config={{
                                height: '150px',
                                width: '600px',
                            }}
                        />

                        <form action="" className='mt-3'>
                            <div className="form-group">
                                <div className="input-group">
                                    <label className="label">Upload files</label>
                                    <div className="file-upload-wrapper">
                                        <label htmlFor="file-upload" className="file-upload-label">
                                            <IoCloudUploadOutline />
                                            <p>Choose files</p>
                                        </label>
                                        <input
                                            type="file"
                                            id="file-upload"
                                            className="file-upload-input"
                                            name="photos"
                                            multiple
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div className="submit-button">
                            <div className="dropdown">
                                <button className="dropbtn" onClick={() => setShowDropdown(!showDropdown)}>
                                    {selectedOption}
                                </button>
                                {showDropdown && (
                                    <div className="dropdown-content">
                                        {options.map((option, index) => (
                                            <div onClick={() => handleOptionClick(option)}>
                                                <div
                                                    key={index} s
                                                    className="dropdown-item"
                                                    style={{ color: option.color }}
                                                >
                                                    ●
                                                </div>
                                                <p>{option.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default ReplyTicket